export default __webpack_public_path__ + "static/media/vb-eye.40277f10.png";